<template>
  <span
    ref="target"
    :class="[{ colored: color, loaded: loaded }, appearEffect]"
    class="mask fade-in"
  >
    <span class="color" />
  </span>
</template>
<script lang="ts" setup>
import { computed } from 'vue';
interface GraphicProps {
  src: string;
  color?: string;
  size?: number;
  appearEffect?: 'fade-in' | '';
}
const props = defineProps({
  src: null,
  color: null,
  size: { default: 2.5 },
  appearEffect: { default: '' }
});
const url = computed(() => {
  return `url(${props.src})`;
});
const csssize = computed(() => {
  return `${props.size}rem`;
});
const loaded = ref<boolean>(false);
const img = new Image();
img.addEventListener('load', () => {
  loaded.value = true;
});
img.src = props.src;
</script>
<style lang="scss" scoped>
.mask {
  display: block;
  width: v-bind(csssize);
  height: v-bind(csssize);
  mask-image: v-bind(url);
  mask-mode: 'match-source';
  mask-size: contain;
  mask-position: center;
  mask-repeat: no-repeat;

  .color {
    display: block;
    width: v-bind(csssize);
    height: v-bind(csssize);
    transition: background-color 200ms $ease-out-quad;
    background: var(--color);
  }

  &.colored {
    .color {
      background: v-bind(color);
    }
  }
}
.fade-in {
  transition: opacity 100ms $ease-in-circ 10ms;
  opacity: 0;
  &.loaded {
    opacity: 1;
  }
}
</style>
